// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"627":"9a7064db","903":"32d4ed8e"}[chunkId] + ".chunk.css";
};